import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { hasWorkspaceTabs } from 'state/workspaces/tabs/tabs.selector';

export function redirectToOrdersBlotterEpic(): EpicWithThunk {
  return (actions$, state$, { navigateTo }) => {
    return actions$.pipe(
      ofType('WORKSPACE_TAB_REMOVED', 'ROUTE_CHANGED', 'WORKSPACE_TABS_ALL_REMOVED'),
      filter(
        action =>
          (action.type === 'ROUTE_CHANGED' && action.path === '/secondary-market-post-event-workspace') ||
          (action.type === 'WORKSPACE_TAB_REMOVED' && action.workspace === 'secondaryMarketPostEvents') ||
          (action.type === 'WORKSPACE_TABS_ALL_REMOVED' && action.workspace === 'secondaryMarketPostEvents'),
      ),
      withLatestFrom(state$),
      filter(([_action, state]) => !hasWorkspaceTabs(state, 'secondaryMarketPostEvents')),
      mergeMap(() => {
        navigateTo('/secondary-orders-blotter');
        return EMPTY;
      }),
    );
  };
}
